"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var useScrollPosition_1 = require("./useScrollPosition");

Object.defineProperty(exports, "useScrollPosition", {
  enumerable: true,
  get: function get() {
    return useScrollPosition_1.useScrollPosition;
  }
});